import { defineComponent, Transition } from "vue";

export default defineComponent({
    props: {
        message: {
            type        : String,
            required    : true,
        },
        overlay: {
            type        : Boolean,
            default     : true,
        },
        visible: {
            type        : Boolean,
            default     : true,
        },
    },

    setup(props) {
        return () => (
            <Transition name="boot-overlay">
                {props.visible && (
                    <div class={["boot-screen", props.overlay && "boot-screen-overlay"]}>
                        <div class="boot-brand">
                            <img class="landing-brand-mark" src="/assets/img/icon.svg" alt="" aria-hidden="true" />
                            <span>LOGSCORD</span>
                        </div>

                        <div class="boot-spinner" />
                        <p>{props.message}</p>
                    </div>
                )}
            </Transition>
        );
    },
});
